<template>
  <folder-selector
    :folders="folders"
    :can-edit="isManager || privateCollateralEnabled"
    @change-folder="onChangeFolder"
    @create="onCreateFolder"
    @delete="onDeleteFolder"
  />
</template>

<script>
import { EventBus } from '@/event-bus';
import FolderSelector from './FolderSelector';

export default {
  name: 'FolderSelectorContainer',
  components: { FolderSelector },
  props: {
    nofolder: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    selected() {
      if (this.$route.params.folderId) {
        return this.$route.params.folderId;
      }
      return -1;
    },
    fetchedFolders() {
      // real backend folders
      if (!this.$store.state.folders.items) return [];
      return this.$store.state.folders.items.concat();
    },
    folders() {
      // formatted for folder-selector
      const folders = [this.all_folder];
      if (this.useFeature('display_shared_collages')) {
        folders.push(this.shared_folder);
      }
      folders.push(...this.fetchedFolders);

      return folders.map((f) => ({
        ...f,
        selected: this.current && this.current.pk === f.pk && !this.nofolder,
        editable: this.$store.state.account.user.profile.url === f.owner || this.isManager,
      }));
    },
    current() {
      if (this.$route.path.includes('shared')) {
        return this.shared_folder;
      }
      if (this.selected < 0) return this.all_folder;
      return this.$store.state.folders.item;
    },
    all_folder() {
      return {
        pk: -1,
        name: 'All',
        files_count: this.fetchedFolders.map((folder) => folder.files_count).reduce((a, b) => (a + b), 0),
      };
    },
    shared_folder() {
      return {
        name: 'Shared Collages',
        shared: true,
      };
    },
    isManager() {
      return this.$store.state.account.user.profile.role.includes('manager');
    },
    privateCollateralEnabled() {
      return this.useFeature('private_collateral');
    },
    isAdminMode() {
      return this.$store.state.account.isAdminMode;
    },
  },
  watch: {
    selected(newval) {
      this.fetchFiles(newval);
    },
  },
  mounted() {
    this.fetchEverything();
  },
  methods: {
    fetchEverything() {
      this.$store.dispatch('folders/getAll');
      this.fetchFiles(this.selected);
    },
    onChangeFolder(newfolder) {
      let route = `/collateral/folder/${newfolder.pk >= 0 ? (`${newfolder.pk}/`) : ''}`;
      if (newfolder.pk === this.current.pk) {
        return;
      } if (newfolder.shared !== undefined && newfolder.shared) {
        route = '/collateral/folder/shared';
      }
      this.$router.push(route);
    },
    onDeleteFolder(folderPk) {
      console.log('Will delete folder', folderPk);
      this.selected = this.all_folder.pk;
      this.$store.dispatch('folders/deleteItem', folderPk).then(() => {
        this.$router.push('/collateral');
        this.fetchEverything();
      });
    },
    onCreateFolder(name) {
      const isPrivate = this.privateCollateralEnabled && !(this.isManager && this.isAdminMode);
      this.$store.dispatch('folders/newItem', { name, private: isPrivate })
        .then((response) => {
          this.selected = response.data.pk;
          this.$store.dispatch('folders/getAll');
        }).catch((error) => {
          console.error('Could not create folder: ', error);
          EventBus.$emit('toast-error', 'Failed to create folder. Please try again');
        });
    },
    fetchFiles(folderPk) {
      if (this.$route.path.includes('shared')) {
        this.$store.commit('folders/updateItem', this.shared_folder);
      } else if (folderPk < 0) {
        this.$store.commit('folders/updateItem', this.all_folder);
      } else {
        this.$store.dispatch('folders/getItem', folderPk);
      }
    },
  },
};
</script>
